const data = {
  title: "Floor 3-2",
  musicTrack: "MUSIC_WORLD3",
  theme: "PINK",
  tilesWidth: 11,
  tilesHeight: 3,
  placements: [
    {
      type: "HERO_SPAWN",
      x: 2,
      y: 2
    },
    {
      type: "PLACEMENT_TYPE_GOAL",
      x: 10,
      y: 2
    },
    {
      type: "FIRE",
      x: 8,
      y: 5
    },
    {
      type: "FIRE",
      x: 8,
      y: 6
    },
    {
      type: "FIRE",
      x: 8,
      y: 7
    },
    {
      type: "ICE_BOOTS",
      x: 8,
      y: 4
    },
    {
      type: "ICE",
      x: 4,
      y: 2
    },
    {
      type: "ICE",
      x: 6,
      y: 2
    },
    {
      type: "ICE",
      x: 5,
      y: 2
    },
    {
      type: "ICE",
      x: 7,
      y: 5
    },
    {
      type: "ICE",
      x: 6,
      y: 5
    },
    {
      type: "ICE",
      x: 5,
      y: 5
    },
    {
      type: "ICE",
      x: 4,
      y: 5
    },
    {
      type: "ICE",
      x: 4,
      y: 6
    },
    {
      type: "ICE",
      x: 4,
      y: 7
    },
    {
      type: "ICE",
      x: 5,
      y: 7
    },
    {
      type: "ICE",
      x: 5,
      y: 6
    },
    {
      type: "ICE",
      x: 6,
      y: 6
    },
    {
      type: "ICE",
      x: 6,
      y: 7
    },
    {
      type: "ICE",
      x: 7,
      y: 7
    },
    {
      type: "ICE",
      x: 7,
      y: 6
    },
    {
      type: "ICE",
      x: 4,
      y: 4
    },
    {
      type: "ICE",
      x: 6,
      y: 4
    },
    {
      type: "ICE",
      x: 5,
      y: 4
    },
    {
      type: "ICE",
      x: 7,
      y: 4
    },
    {
      type: "ICE_BOOTS",
      x: 8,
      y: 2
    },
    {
      type: "WALL",
      x: 4,
      y: 1
    },
    {
      type: "WALL",
      x: 6,
      y: 1
    },
    {
      type: "WALL",
      x: 4,
      y: 3
    },
    {
      type: "WALL",
      x: 6,
      y: 3
    },
    {
      type: "CHIP",
      x: 5,
      y: 1
    },
    {
      type: "CHIP",
      x: 5,
      y: 3
    },
    {
      type: "ICE",
      x: 5,
      y: 3
    },
    {
      type: "ICE",
      x: 5,
      y: 1
    }
  ]
};

export default data;
